import { accordionSummaryClasses } from '@mui/material';
// MUI Imports
import type { Theme } from '@mui/material/styles';
import type { Skin } from '../../materio/@core/types';
import { DsIcon } from '../icons/DsIcon';

const MuiAccordion = (_skin: Skin): Theme['components'] => ({
  MuiAccordion: {
    styleOverrides: {
      root: ({ theme }) => ({
        background: 'transparent',
        padding: 0,
        margin: 0,
        border: 'none !important',
        boxShadow: 'none',
        transition: 'none',
        '&.Mui-expanded': {
          margin: theme.spacing(0, 0),
        },
        '&::before': {
          display: 'none',
        },
      }),
    },
  },
  MuiAccordionSummary: {
    defaultProps: {
      expandIcon: <DsIcon icon="CHEVRON_RIGHT" color="iceGray.700" />,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]: {
          transform: 'rotate(90deg)',
        },
        flexDirection: 'row-reverse',
        gap: '6px !important',
        padding: '0 !important',
        '&.Mui-expanded': {
          minHeight: 48,
        },
      }),
      content: {
        margin: '0 !important',
      },
    },
  },
  MuiAccordionDetails: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: theme.spacing(0, 0, 0),
      }),
    },
  },
});

export default MuiAccordion;
